import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-custom-dimensions-grid-view',
  templateUrl: './custom-dimensions-grid-view.component.html',
  styleUrls: ['./custom-dimensions-grid-view.component.scss'],
  imports:[DependenciesModule]
})
export class CustomDimensionsGridViewComponent implements OnInit,AfterViewInit {
  @ViewChildren('lazyImage') lazyImages!: QueryList<ElementRef<HTMLImageElement>>;
  @Input() gridData;
  @Input() nameSort:boolean = false;
  @Input() customHeight: any;
  @Input() customWidth: any;
  universalService:any;
  showFavoriteIcon:boolean = true;
  @Input() showCheckBox:boolean = true;
  public router: any;
  contextMenuService:any;
  @Input() showNameOnThumbnails:boolean = false;
  db: IndexedDBModule;

  @Input() showMoreOptionsIcon: boolean = true;
  @Output()
  gridItemSelected: EventEmitter<object> = new EventEmitter<object>()
  customMetadataService: any;
  lazyLoadImgService:any;
  cleverTapEventsService:any;
  public peopleService:any;
  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService)
   
   }

  ngOnInit(): void {
    setTimeout(() => {
      this.setThumbnailDimensions();
    }, 50);
    this.checkIfFavoriteIconShouldBeShown();
  }
  
  ngAfterViewInit() {
    this.lazyImages.changes.subscribe(() => {
      this.observeImages();
    });

    this.observeImages();
  }

  ngOnDestroy() {
    this.lazyImages.forEach(image => this.lazyLoadImgService.unregisterImage(image.nativeElement));
  }

  observeImages() {
    this.lazyImages.forEach(image => this.lazyLoadImgService.registerImage(image.nativeElement));
  }



  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.db = IndexedDBModule.getInstance(globalService);
    this.customMetadataService = globalService.getCustomMetadataServiceRef();
    this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
    this.peopleService = globalService.getPeopleServiceRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
   }

   checkIfFavoriteIconShouldBeShown(){
    if(this.universalService.currentTab == 'Favorites'){
      this.showFavoriteIcon = false;
    }else{
      this.showFavoriteIcon = true;
    }

    if(this.universalService.currentAlbum){
      this.showCheckBox = true
    }
  }

  async itemClicked(object){
    if(this.universalService.currentTab == "People"){
      this.universalService.selectedFace = undefined;
      this.cleverTapEventsService.individualFaceClicked('People_Screen');
      this.setPeopleContainerPosition();
      this.router.navigate(['/people/face',object.objectKey]);
      return
    }else if(this.universalService.currentTab == "Places"){
      this.universalService.selectedPlace = undefined;
      // this.cleverTapEventsService.individualFaceClicked('People_Screen');
      this.setPeopleContainerPosition();
      this.router.navigate(['/places/place',object.placeKey]);
      return
    }
    if(this.router.url.includes("/search") && object.objectType == 'FE'){
      var obj = this.customMetadataService.segregateData([object],'allfiles');
      this.universalService.selectedNodes[0] = obj[0];
  
      if(this.universalService.isMobileDevice){
        this.universalService.selectedFile = object
        await this.contextMenuService.decideContextMenuItems();
      }
      this.universalService.openPreview(object);
      this.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file
    }
  }

  setPeopleContainerPosition() {
    let savedScrollPosition = document.getElementById("peopleWrapper").scrollTop;
    this.peopleService.setScrollPosition(savedScrollPosition);
  }

/* Calculating dynamically in below method 
  setCustomHeightAndWidth(){
    var fullWidth = $('.custom-image-thumb-gallery').innerWidth();
    var noOfThumbnailsToFit = Math.floor(fullWidth/this.customWidth);
    var noOfSpaces = noOfThumbnailsToFit + 1 ;
    var marginPx = (fullWidth - (noOfThumbnailsToFit * this.customWidth))/noOfSpaces;
    var marginPx = 8;//noOfThumbnailsToFit + 5;
    var containerMargin = "-" + marginPx + "px";
    $('.custom-thumb-img-holder').css({'height':this.customHeight+"px",'width':this.customWidth+"px",'margin':marginPx+"px"});
    const $elem = $('.custom-image-thumb-gallery');
    if($elem[0]){ 
      $elem[0].style.setProperty('margin-left', containerMargin , 'important');
    }
  }*/

  //Based on no. of tiles to fit, calculating width and adjusted aspect ration of height
  setCustomHeightAndWidth(){
    var fullWidth = $('.custom-image-thumb-gallery').innerWidth();
    var noOfThumbnailsToFit = this.universalService.currentTab == 'Places' ? 6 : 8; // Tiles to show
    var marginPx = 4;
    fullWidth = (fullWidth - (noOfThumbnailsToFit * marginPx));
    var calcTileWidth = 0;
    var calcTileHeight = 0;
    calcTileWidth = (Math.floor(fullWidth/noOfThumbnailsToFit) - (marginPx * 2));
    calcTileHeight = Math.floor(calcTileWidth/0.75); //3:4 ratio
    $('.custom-thumb-img-holder').css({'height':calcTileHeight+"px",'width':calcTileWidth+"px",'margin':marginPx+"px"});
    $('.custom-default-thumbnail-icon').css({'height':calcTileHeight+"px",'width':calcTileWidth+"px"});
    
    const $elem = $('.custom-image-thumb-gallery');
    if($elem[0]){ 
      $elem[0].style.setProperty('margin-left', marginPx + 'px' , 'important');
      $elem[0].style.setProperty('display', 'flex');
    }
  }

  setThumbnailDimensions(){
    var self = this;
    self.setCustomHeightAndWidth();
    $(window).resize(function () {
      setTimeout(() => {
        self.setCustomHeightAndWidth();
      }, 200);
      
    });
  }

}
